import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop errors (benign warnings from Radix UI)
const resizeObserverErr = window.onerror;
window.onerror = function(message, source, lineno, colno, error) {
  if (message && message.includes && message.includes('ResizeObserver loop')) {
    return true; // Suppress the error
  }
  return resizeObserverErr ? resizeObserverErr(message, source, lineno, colno, error) : false;
};

// Also suppress in error event listener
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
